module.exports = __webpack_public_path__ + "img/add-first-timer.07dbdd7e.svg";